import {
  IGetRemittanceWithIncompleteDeductionsParams,
  IRemittanceRepository,
  IRemittanceRepositoryResponse,
} from "@/core/repositories/remittance";

export class GetRemittanceWithIncompleteDeductionsUseCase {
  constructor(private readonly remittanceRepository: IRemittanceRepository) {}

  async execute(
    params: IGetRemittanceWithIncompleteDeductionsParams,
    refetch: boolean = false
  ): Promise<IRemittanceRepositoryResponse> {
    return this.remittanceRepository.getRemittanceWithIncompleteDeductions(params, refetch);
  }
}
